import {Children, ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TicketCardCarousel.css';
import CarouselArrows from './CarouselArrows';
import CarouselDots from './CarouselDots';
import useSnapCarousel from './useSnapCarousel';
import SwipeHand from '../../../assets/icons/SwipeHand';

interface TicketCardCarouselProps {
    children: ReactNode;
    'data-cy'?: string;
}

function TicketCardCarousel({children, 'data-cy': dataCy = 'entrance-ticket-carousel'}: TicketCardCarouselProps) {
    const {t} = useTranslation('eTicket');
    const cards = Children.toArray(children);
    const {viewportRef, activeIndex, scrollToIndex} = useSnapCarousel(cards.length);
    const hasMany = cards.length > 1;

    return (
        <css.carousel data-cy={dataCy}>
            <css.cardArea>
                <css.viewport ref={viewportRef}>
                    {cards.map((card, index) => (
                        <css.slide
                            key={index}
                            className={index === activeIndex ? 'is-active' : ''}
                            data-carousel-card
                            data-carousel-index={index}
                        >
                            <css.cardFrame>{card}</css.cardFrame>
                        </css.slide>
                    ))}
                </css.viewport>
                {hasMany && <CarouselArrows count={cards.length} activeIndex={activeIndex} onSelect={scrollToIndex} />}
            </css.cardArea>
            {hasMany && <CarouselDots count={cards.length} activeIndex={activeIndex} onSelect={scrollToIndex} />}
            {hasMany && (
                <css.swipeHint className={activeIndex > 0 ? 'is-hidden' : ''} data-cy="entrance-ticket-swipe-hint">
                    <SwipeHand />
                    {t('swipeToScan')}
                </css.swipeHint>
            )}
        </css.carousel>
    );
}

export default TicketCardCarousel;
